import { request as __request } from '../core/request';
export class FrontendFaqService {
    /**
     * [BASE] Search From FAQEntity
     * @returns any Success
     * @throws ApiError
     */
    static findAll({ where, page, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/faq`,
            query: {
                'where': where,
                'page': page,
            },
        });
    }
    /**
     * [BASE] Batch Update To FAQEntity
     * @returns void
     * @throws ApiError
     */
    static batchUpdate({ requestBody, }) {
        return __request({
            method: 'PUT',
            path: `/api/frontend/faq`,
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * [BASE] FindOne From FAQEntity
     * @returns any Success
     * @throws ApiError
     */
    static findOne({ id, }) {
        return __request({
            method: 'GET',
            path: `/api/frontend/faq/${id}`,
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
